import {
	ExperiencePerformanceTypes,
	ExperienceTypes,
	UFOExperience,
} from '@atlassian/ufo/ufo-experimental';

const createConversationWithMessageExperienceId =
	'service-management.help-center.omnichannel.combined-api';

export const createConversationWithMessageExperience = new UFOExperience(
	createConversationWithMessageExperienceId,
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
